import { render, staticRenderFns } from "./user.vue?vue&type=template&id=1b13e4f2&scoped=true"
import script from "./user.vue?vue&type=script&lang=ts"
export * from "./user.vue?vue&type=script&lang=ts"
import style0 from "./user.vue?vue&type=style&index=0&id=1b13e4f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b13e4f2",
  null
  
)

export default component.exports